// extracted by mini-css-extract-plugin
module.exports = {"container":"HomepageLayout_container_3a-5i","imageWrapper":"HomepageLayout_imageWrapper_3xe3N","image":"HomepageLayout_image_3ZM7e","content":"HomepageLayout_content_3lEan"};